<div class="modal__header">
	<h2 class="title" id="modal__title">{{ 'modals.compareFares.title.compareFares' | ibeadmin: 'sync' }}</h2>
	<div class="modal__header-actions">
		<button aria-label="Close dialog" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<div #modal class="modal__body sl--scrollable compare-brand-content">
	<div class="container" *ngIf='!hideCabin'>
		<div class="compare-brand-tabs" role="tablist" aria-label="Cabins">
			<ng-container *ngFor="let brand of brandsList; let index = index" >
				<button class="compare-brand-tabs__cabin" [ngClass]="{ selected: INDRA_isCabinSelected(index) }" (click)="INDRA_selectCabin(index, $event)"
					role="tab" [attr.aria-selected]="INDRA_isCabinSelected(index)" [attr.aria-controls]="'cabin-tab-' + index"  [attr.id]="'cabin-' + index">
					{{ brand.label }}
				</button>
			</ng-container>
		</div>
	</div>

	<app-expand-collapse [state]="INDRA_brandsState">
		<div *ngFor="let list of brandsList; let listIndex = index" tabindex="0" role="tabpanel" [attr.aria-labelledby]="'cabin-' + listIndex"  [attr.id]="'cabin-tab-' + listIndex">
			<div class="container table-header no-pad-h hidden-mobile" *ngIf="INDRA_showBrands(listIndex)">
				<div class="grid table-header--row">
					<div class="col-3 col-tp-3 col-p-3 table-header--cell">
						&nbsp;
					</div>

					<div class="col-9 col-tp-9 col-p-9">
						<div class="grid">
							<div class="table-header--cell" [ngClass]="INDRA_brandStyles(listIndex)" *ngFor="let brand of list.brands;">
								<div class="brand brand--{{brand.name}}">
									<app-svg aria-hidden=true svg="sprite.svg#brand--{{brand.name}}" [alt]="brand.name + ' logo'"></app-svg>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

			<ng-container *ngIf="INDRA_showBrands(listIndex)">
				
				<div class="container table no-pad-h no-pad-top" *ngFor="let arrFeature of features;">
					<div class="grid top-gap table--row" *ngFor="let feature of arrFeature;">
						<div class="col-3 col-tp-3 col-p-12 table--cell first">
							<div class="icon">
								<app-svg aria-hidden=true svg="icons.svg#{{feature.icon}}" [alt]="feature.label + ' icon'"></app-svg>
							</div>
							<button [id]="feature.id" (click)="footerInfo(feature.id + '-note')" *ngIf="feature.link !== null" class="link">
								<p>{{ feature.label | ibeadmin: 'sync' }}<sup>{{ feature.sup }}</sup></p>
							</button>
							<p *ngIf="feature.link === null">{{ feature.label | ibeadmin: 'sync' }}</p>
						</div>
						<div class="col-9 col-tp-9 col-p-12">
							<div class="grid">
								<div class="table--cell grid" [ngClass]="INDRA_brandStyles(listIndex)" *ngFor="let brand of list.brands;">

									<div class="col-6 col-tp-6 col-p-6 hidden-tablet-portrait-up">
										<div class="brand brand--{{brand.name}}">
											<app-svg aria-hidden=true svg="sprite.svg#brand--{{brand.name}}" [alt]="brand.name + ' logo'"></app-svg>
										</div>
									</div>

									<div class="col-12 col-tp-12 col-p-6">
										<div class="brand-cell" *ngIf="feature[brand.name] !== true; else elseBrand;">
											<p [innerHTML]="feature[brand.name] | ibeadmin: 'sync'"></p>
										</div>

										<ng-template #elseBrand>
											<app-svg aria-hidden=true class="icon" svg="sprite.svg#misc--check" [alt]="'Checked icon'"></app-svg>
										</ng-template>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>

			</ng-container>

		</div>
	</app-expand-collapse>


	<app-notification [style]="'information'" class="bottom-gap">
		<div message>
			<p class="notification-text">
				{{ 'modals.compareFares.text.infoText1' | ibeadmin: 'sync' }}
				<a href="javascript:;" (click)="INDRA_gotoURL('externalURLs.compareLearnMore')" class="link link--external" aria-label="Learn more about conditions, open window">
					{{ 'modals.compareFares.link.learnMore' | ibeadmin: 'sync' }}
					<span class="visuallyhidden">
						{{ 'modals.compareFares.link.linkOpenWindow' | ibeadmin: 'sync' }}
					</span>
				</a>
			</p>
		</div>
	</app-notification>

	<div class="disclaimer">
		<ul>
			<li id="changes-footnote-oldbrands-note">
				<button class="link" (click)="footerInfo('changes-footnote-oldbrands')"><sup>1</sup> {{ 'modals.compareFares.link.changesCancellation' | ibeadmin: 'sync' }}</button>: {{ 'modals.compareFares.text.changeCancellationText1' | ibeadmin: 'sync' }}
				<p>{{ 'modals.compareFares.text.changeCancellationText2' | ibeadmin: 'sync' }}</p>
			</li>
			<li id="fasttrack-footnote-oldbrands-note">
				<button class="link" (click)="footerInfo('fasttrack-footnote-oldbrands')"><sup>2</sup> {{ 'modals.compareFares.link.fastTrack' | ibeadmin: 'sync' }}</button>: {{ 'modals.compareFares.text.fastTrackText1' | ibeadmin: 'sync' }} 
				<a class="link" href="https://www.flytap.com/en-pt/at-the-airport/fast-track?tabid=filters-tabf8230945-2d8c-4467-88d3-b94a6ad16fd4&accordionid=1" 
					target="_blank" title="Fast Track information">{{ 'modals.compareFares.link.here' | ibeadmin: 'sync' }}
					<span class="visuallyhidden">{{ 'modals.compareFares.link.linkOpenWindow' | ibeadmin: 'sync' }}</span>
				</a>. {{ 'modals.compareFares.text.fastTrackText2' | ibeadmin: 'sync' }} 
			</li>
			<li id="lounge-footnote-oldbrands-note">
				<button class="link" (click)="footerInfo('lounge-footnote-oldbrands')"><sup>3</sup> {{ 'modals.compareFares.link.lounge' | ibeadmin: 'sync' }}</button>: {{ 'modals.compareFares.text.loungeText1' | ibeadmin: 'sync' }} 
				<a class="link" href="https://www.flytap.com/en-pt/at-the-airport/lounges?accordionid=2" target="_blank" 
					title="Lounge access information">{{ 'modals.compareFares.link.here' | ibeadmin: 'sync' }}
					<span class="visuallyhidden">{{ 'modals.compareFares.link.linkOpenWindow' | ibeadmin: 'sync' }}</span>
				</a>. {{ 'modals.compareFares.text.loungeText2' | ibeadmin: 'sync' }}
			</li>

		</ul>
	</div>

</div>
